export default [
  {
    path: '/b2bhub/Boleto',
    name: 'boleto',
    component: () => import('@/views/app/PTC/Boleto/viewBoleto.vue'),
    meta: {
      pageTitle: 'Boleto',
      action: 'read',
      resource: 'Acesso_Boleto',
    },

  },
];
